import { render, staticRenderFns } from "./TeamOrganizationPopup.vue?vue&type=template&id=0a1737cd&scoped=true&"
import script from "./TeamOrganizationPopup.vue?vue&type=script&lang=js&"
export * from "./TeamOrganizationPopup.vue?vue&type=script&lang=js&"
import style0 from "./TeamOrganizationPopup.vue?vue&type=style&index=0&id=0a1737cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1737cd",
  null
  
)

export default component.exports